import { type ComponentPropsWithoutRef, type ReactNode } from "react";
import { usePillarTableFilterState } from "shared/components/pillar-table/filters/hooks/usePillarTableFilterState";
import PillarTableFilterLabel from "shared/components/pillar-table/filters/PillarTableFilterLabel";
import { withoutOptionSourceCollection } from "shared/components/pillar-table/filters/PillarTableFilterOptionSources";

type PillarTableFilterCheckboxProps = Omit<
  ComponentPropsWithoutRef<"input">,
  "onChange" | "value" | "type" | "name" | "title"
> & {
  title: string;
  filterKey: string;
  isRowStyle?: boolean;
  toolTip?: ReactNode;
};

const PillarTableFilterCheckbox = ({
  filterKey,
  title,
  isRowStyle,
  toolTip,
  defaultChecked = false,
  ...props
}: PillarTableFilterCheckboxProps) => {
  const { setFilterValue, filterValue } = usePillarTableFilterState<boolean>({
    filterKey,
    defaultValue: defaultChecked,
  });

  return (
    <div
      className={
        isRowStyle
          ? "flex flex-row justify-center items-center gap-0.5 pb-0.75 pt-0.5"
          : "flex flex-col justify-start items-start"
      }
    >
      <PillarTableFilterLabel
        className="pillartable-filters-selectmenu-button-title"
        htmlFor={`filter-checkbox-input-${filterKey}`}
        filterKey={filterKey}
        title={title}
        toolTip={toolTip}
      />
      <input
        id={`filter-checkbox-input-${filterKey}`}
        name={`filter-checkbox-input-${filterKey}`}
        title={title}
        checked={filterValue}
        type="checkbox"
        onChange={(e) => {
          setFilterValue(e.target.checked);
        }}
        {...props}
      />
    </div>
  );
};

export default withoutOptionSourceCollection(PillarTableFilterCheckbox);
